/* eslint-disable */
export default {
  confirmation: 'Confirmation',
  confirmMergeToConference: 'Ajouter à la conférence téléphonique ?',
  mergeToConference: 'Fusionner',
  conferenceCall: 'Conférence téléphonique',
} as const;

// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
